import {PUBLIC_PRODUCT_FILTER_CONFIG} from '@/submodule/decorate_manage/components/unit_edit_config_public.js'

const config = {
	product_list: [{
		tab: '内容设置',
		content: PUBLIC_PRODUCT_FILTER_CONFIG()
	}],
	
	live_list: [{
		tab: '内容设置',
		content: [{
			label: '标题图片',
			type: 'image',
			code: 'title'
		}, {
			label: '副标题',
			type: 'input',
			code: 'message'
		}, {
			label: '观看按钮颜色',
			type: 'color',
			code: 'alive_btn_color'
		}, {
			label: '预约按钮颜色',
			type: 'color',
			code: 'btn_color'
		}, {
			label: '预约描述',
			type: 'input',
			code: 'description'
		}]
	}],
	
	waterfall_flow: [{
		tab: '系统推荐',
		content: [{
			label: '是否显示',
			type: 'radio',
			code: 'show',
			options: [{
				name: '显示',
				value: '1'
			}, {
				name: '不显示',
				value: '0'
			}]
		}, {
			label: '标题文字',
			type: 'input',
			code: 'title_text'
		}, {
			label: '副标题',
			type: 'input',
			code: 'sub_title'
		}]
	}, {
		tab: '自定义标签',
		content: [{
			type: 'list',
			code: 'tabs',
			length: 3,
			content: [{
				label: '是否显示',
				type: 'radio',
				code: 'show',
				options: [{
					name: '显示',
					value: '1'
				}, {
					name: '不显示',
					value: '0'
				}]
			}, {
				label: '标题文字',
				type: 'input',
				code: 'title_text'
			}, {
				label: '副标题',
				type: 'input',
				code: 'sub_title'
			}].concat(PUBLIC_PRODUCT_FILTER_CONFIG())
		}]
	}]
}

export default config;